import SegmentedControl from './SegmentedControl';

// export types
export type { SegmentedControlProps, SegmentedItemDataType } from './SegmentedControl';

// export components
export { SegmentedControl };
export default SegmentedControl;
